import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import ReactSVG from 'react-svg';
import rightArrow from '../assets/graphics/arrow-right.svg';
import IconButton from "./icon-button";

// Use onClick prop to overwrite the default goBack function.

class BackButton extends Component {

    constructor( props ){
        super( props );

        this._onClick = this._onClick.bind(this);
    }

    _onClick() {
        const { onClick, goBack } = this.props;
        if( onClick !== false ){
            onClick();
        }else{
            goBack();
        }
    }

    render() {
        return(
            <IconButton className="icon-btn-back" onClick={ this._onClick }>
                <ReactSVG src={ rightArrow } className="left-arrow" />
            </IconButton>
        );
    }

}

const mapDispatchToProps = ( dispatch ) => {
    return {
        goBack: () => {
            dispatch( goBack() );
        }
    }
};

export default connect(null,mapDispatchToProps)(BackButton);


// WEBPACK FOOTER //
// ./src/components/back-button.js